import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {Dialog, withStyles} from "@material-ui/core";
import * as actions from './store/adminDiagnoseCaseActions';
import {checkIfLoading} from "../../sc-users/User";
import AppLogoLoading from "../../sc-logo";
import {hasPermission, parseURL} from "../../sc-utilities";
import * as Yup from "yup";
import History from "../../../History";
import AdminDiagnoseCaseForm from "./AdminDiagnoseCaseForm";

const styles = (theme) => ({
    loadingScreen: {
        backgroundColor: "transparent",
        boxShadow: "none",
    },
});

export const diagnoseCaseExecutionTypes = (translations) => [
    {value: "manual", displayValue: translations["manual"] || "Manual"},
    {value: "automatic", displayValue: translations["automatic"] || "Automatic"},
    {value: "assisted", displayValue: translations["assisted"] || "Assisted"}];

export const diagnoseCaseGroups = (translations) => [
    {value: "camera", displayValue: translations["camera"] || "Camera"},
    {value: "communication", displayValue: translations["communication"] || "Communication"},
    {value: "control", displayValue: translations["control"] || "Control"},
    {value: "physicalConnection", displayValue: translations["physical_connection"] || "Physical connection"},
    {value: "screen", displayValue: translations["screen"] || "Screen"},
    {value: "sensors", displayValue: translations["sensors"] || "Sensors"},
    {value: "sound", displayValue: translations["sound"] || "Sound"},
    {value: "system", displayValue: translations["system"] || "System"},
    {value: "storage", displayValue: translations["storage"] || "Storage"}
]

export const supportedClientTypes = (translations) => [
    {value: "work", label: translations["work"] || "Work"},
    {value: "mobile", label: translations["mobile"] || "Mobile"}
]

const AdminDiagnoseCaseDetails = (props) => {
    const { classes, activeCustomerID, translations, permissions, fetchAdminDiagnoseCase, onUpdateAdminDiagnoseCase, onCreateAdminDiagnoseCase } = props;

    const searchParams = parseURL(window.location.href);

    const [diagnoseCase, setDiagnoseCase] = useState(null);
    const [loading, setLoading] = useState({diagnoseCase: false});

    const isEdit = window.location.href.includes("edit");

    useEffect(() => {
        const getDiagnoseCase = async () => {
            setLoading(prevState => {return {...prevState, diagnoseCase: true}});
            const result = await fetchAdminDiagnoseCase({DiagnoseCaseID: searchParams?.DiagnoseCaseID, ActiveCustomerID: activeCustomerID});
            if (result) {
                setDiagnoseCase(result);
            }
            setLoading(prevState => {return {...prevState, diagnoseCase: false}});
        }

        isEdit && getDiagnoseCase();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const initialValues = {
        ShortName: diagnoseCase?.ShortName || null,
        LongName: diagnoseCase?.LongName || null,
        Description: diagnoseCase?.Description || null,
        Visible: !!diagnoseCase?.Visible,
        Group: diagnoseCase?.Group || diagnoseCaseGroups(translations)[0]?.value,
        ExecutionType: diagnoseCase?.ExecutionType || diagnoseCaseExecutionTypes(translations)[0]?.value,
        Key: diagnoseCase?.Key || null,
        ClientType: isEdit? diagnoseCase?.ClientType || "" : supportedClientTypes(translations)[0].value
    }

    const formSettings = {
        Validation: {
            ShortName: Yup.string().required(),
            LongName: Yup.string().required(),
            Description: Yup.string().notRequired().nullable(),
            Visible: Yup.boolean(),
            Group: Yup.string().required(),
            ExecutionType: Yup.string().required(),
            Key: Yup.string().required(),
            ClientType: Yup.string().required()
        },
        FormTitle: isEdit? translations["edit_diagnose_case"] || "Edit diagnose case" : translations["create_diagnose_case"] || "Create diagnose case",
        ButtonSubmit: hasPermission(permissions, isEdit? 'diagnose_case_update' : 'diagnose_case_create') ? {
            Title: translations["save"] || "SAVE"
        } : null
    }

    const handleUpdate = async (data) => {
        await onUpdateAdminDiagnoseCase({...data, DiagnoseCaseID: searchParams?.DiagnoseCaseID, ActiveCustomerID: activeCustomerID});
        History.goBack();
    }

    const handleCreate = async (data) => {
        await onCreateAdminDiagnoseCase({...data, ActiveCustomerID: activeCustomerID});
        History.goBack();
    }

    const loadingScreen = <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={checkIfLoading(loading)} PaperProps={{classes: {root: classes.loadingScreen}}}>
        <AppLogoLoading />
    </Dialog>

    return <>
        {checkIfLoading(loading)? loadingScreen : <AdminDiagnoseCaseForm isEdit={isEdit} formSettings={formSettings} initialValues={initialValues} handleSubmit={isEdit? handleUpdate: handleCreate} translations={translations} /> }
    </>
}

const mapStateToProps = state => {
    return {
        activeCustomerID: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || [],
    };
};
const mapDispatchToProps = dispatch => {
    return {
        fetchAdminDiagnoseCase: id => dispatch(actions.fetchAdminDiagnoseCase(id)),
        onCreateAdminDiagnoseCase: data => dispatch(actions.createAdminDiagnoseCase(data)),
        onUpdateAdminDiagnoseCase: data => dispatch(actions.updateAdminDiagnoseCase(data))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(AdminDiagnoseCaseDetails));
